import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PracticeFeaturePermissionService } from '../../user/services/practice-feature-permission-service';
import { practiceFeaturesInformation } from '../../practice/store/state/practice-info';

@Directive({
  selector: '[appPracticeHasFeaturePermission]'
})
export class practiceHasFeaturePermissionDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: PracticeFeaturePermissionService
  ) {}

  @Input() set appPracticeHasFeaturePermission(featureKey: keyof practiceFeaturesInformation) {
    const hasPermission = this.authService.hasPracticeFeaturePermission(featureKey);

    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}